/* eslint-disable import/no-cycle */
import { handleActions } from 'redux-actions';

// SQS EMAILS CORRPRO ONLY
import { ROOT_SLICE as ROOT_SLICE_SQS_EMAILS_CORRPRO_ONLY } from './slices/SqsEmailsCorrproOnly/constants';
import { initialState as SqsEmailsCorrproOnlyInitialState } from './slices/SqsEmailsCorrproOnly/initialState';
import SqsEmailsCorrproOnlyReducerParts from './slices/SqsEmailsCorrproOnly/reducerParts';

const initialState = {
	[ROOT_SLICE_SQS_EMAILS_CORRPRO_ONLY]: {
		...SqsEmailsCorrproOnlyInitialState
	},
};

const reducerParts = {
	...SqsEmailsCorrproOnlyReducerParts,
};

export default handleActions(reducerParts, initialState);
